export default __webpack_public_path__ + "static/life_of_kernel-94c8975b8d0c5642044d537c9323b4af.png";